<freud-card>
	<div>
		<div class="zk-flex zk-gap-5">
			<div class="zk-flex zk-items-center">
				<span
					freud-typography
					fontType="h6Regular1-5"
					class="freud-icon freud-icon-calendar zk-pr-2"
				></span>
				<span freud-typography fontType="h6Regular1-5">{{
					formatedData.date
				}}</span>
			</div>
			<div class="moodtracker__day-of-week">
				<span freud-typography fontType="h6Regular1-5">{{
					formatedData.dayOfWeek
				}}</span>
			</div>
		</div>
		<div
			class="zk-flex zk-flex-col md:zk-flex-row md:zk-gap-8"
			[ngClass]="last ? 'zk-mt-4' : 'zk-my-4'"
			*ngFor="let moodEntry of formatedData.entries; last as last"
		>
			<div class="zk-flex zk-gap-12">
				<div class="zk-flex zk-items-center">
					<span
						freud-typography
						fontType="h6Regular1-5"
						class="freud-icon freud-icon-clock zk-pr-2"
					></span>
					<span freud-typography fontType="h6Regular1-5">{{
						moodEntry.time
					}}</span>
				</div>
				<div class="zk-flex zk-items-center">
					<span
						class="zk-hidden freud-icon freud-icon-box freud-icon-large zk-mx-1"
					></span>
					<span
						class="moodtracker__emotion"
						freud-typography
						fontType="h5Semibold1-5"
						>{{ moodEntry.emotion.name }}</span
					>
				</div>
			</div>
			<div>
				<freud-tag
					class="zk-inline-block zk-py-2 zk-pr-2 md:zk-py-0 zk-w-fit"
					[outline]="true"
					*ngFor="let reason of moodEntry.reasons"
					[value]="reason.name"
				></freud-tag>
			</div>
		</div>
	</div>
</freud-card>
